import {Settings} from '@mui/icons-material';
import {Alert, Button, Typography} from '@mui/material';
import {useNavigate} from 'react-router';

export default function ExerciseNoModule() {
  const navigate = useNavigate();
  return (
    <Alert
      severity="info"
      sx={{mb: 3}}
      data-testid="no-modules-alert"
      action={
        <Button
          onClick={() => navigate('/settings/module')}
          variant="outlined"
          size="small"
          startIcon={<Settings />}
          sx={{ml: 2}}
          data-testid="add-module-button"
        >
          Add Module
        </Button>
      }
    >
      <Typography variant="body2">
        You haven&apos;t selected any study modules yet. Add a module to start your revision journey!
      </Typography>
    </Alert>
  );
}
